import { compile } from 'path-to-regexp'


type Params = {
  [key: string]: string | number
}

const cache = {}

const stringifyObjectNumbers = (obj) => {
  const result = {}
  for (const [ key, value ] of Object.entries(obj)) {
    result[key] = typeof value === 'number' ? String(value) : value
  }
  return result
}

const getLinkWithParams = (link: string, params?: Params, encode: Boolean = false) => {
  if (!cache[link]) {
    cache[link] = compile(link, {
      encode: encode ? encodeURIComponent : undefined,
    })
  }

  return cache[link](stringifyObjectNumbers(params))
}


export default getLinkWithParams
